import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState, useEffect, useContext } from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { BusinessPropType } from '../../../../../../services/proptypes';
import { cleanDomainName } from '../../../../../../utils/urls';
import { DomainContext } from '../../DaySmartPublishModal.context';
import { INTERNAL_DOMAIN_TYPE, EXTERNAL_DOMAIN_TYPE } from './DomainSelect.constants';
import { submitDomainInformation } from './DomainSelect.utils';
import DomainSearchForm from './components/DomainSearchForm';
import ExternalDomainInputForm from './components/ExternalDomainInputForm';
import './DomainSelect.css';
var defaultProps = {
  domainSeedValue: '',
  onComplete: function onComplete() {
    return null;
  },
  onFailure: function onFailure() {
    return null;
  }
};
export default function DomainSelect(_ref) {
  var business = _ref.business,
      domainSeedValue = _ref.domainSeedValue,
      onComplete = _ref.onComplete,
      onFailure = _ref.onFailure;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      submissionError = _useState4[0],
      setSubmissionError = _useState4[1];

  var _useContext = useContext(DomainContext),
      domain = _useContext.domain,
      domainType = _useContext.domainType,
      setDomain = _useContext.setDomain,
      setDomainType = _useContext.setDomainType;

  useEffect(function () {
    setDomainType(domainType || INTERNAL_DOMAIN_TYPE);
    setDomain(cleanDomainName(domain));
  }, []);

  function onDomainTypeChange(type) {
    setDomainType(type);
  }

  function onSubmitDomain(_x) {
    return _onSubmitDomain.apply(this, arguments);
  }

  function _onSubmitDomain() {
    _onSubmitDomain = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(selectedDomain) {
      var payload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setDomain(selectedDomain);
              payload = {
                domainType: domainType,
                domainName: cleanDomainName(selectedDomain)
              };
              _context.prev = 2;
              setLoading(true);
              _context.next = 6;
              return submitDomainInformation(business, payload);

            case 6:
              onComplete();
              _context.next = 13;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              onFailure();
              setSubmissionError(true);

            case 13:
              _context.prev = 13;
              setLoading(false);
              return _context.finish(13);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 9, 13, 16]]);
    }));
    return _onSubmitDomain.apply(this, arguments);
  }

  var Content = null;

  if (domainType === INTERNAL_DOMAIN_TYPE) {
    Content = /*#__PURE__*/React.createElement(DomainSearchForm, {
      domainName: cleanDomainName(domainSeedValue),
      onChangeDomainType: function onChangeDomainType() {
        return onDomainTypeChange(EXTERNAL_DOMAIN_TYPE);
      },
      onSelect: onSubmitDomain
    });
  }

  if (domainType === EXTERNAL_DOMAIN_TYPE) {
    Content = /*#__PURE__*/React.createElement(ExternalDomainInputForm, {
      onChangeDomainType: function onChangeDomainType() {
        return onDomainTypeChange(INTERNAL_DOMAIN_TYPE);
      },
      onSelect: onSubmitDomain
    });
  }

  if (submissionError) {
    Content = /*#__PURE__*/React.createElement("div", {
      className: "day-smart-error-container"
    }, /*#__PURE__*/React.createElement(Header, {
      as: "h2"
    }, "Domain Submission Error"), /*#__PURE__*/React.createElement("p", null, "Please email support@gofisherman.com with your domain details."));
  }

  return /*#__PURE__*/React.createElement(Segment, {
    className: "day-smart-segment-container",
    loading: loading
  }, Content);
}
DomainSelect.defaultProps = defaultProps;